import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FrtShipmentDeliveryEntity } from 'src/app/shared/common-components/common-structure';

@Injectable({
  providedIn: 'root'
})
export class ShipmentDeliveryDataService extends DataService {

  private baseURI = this.apiUri + '/shipmentDeliveryData/';
  headers = new HttpHeaders({'Content-Type': 'application/json'});
  constructor(http: HttpClient) {
    super(http);
  }

  getShipmentDeliveryDataByFrtBolDetailsId(frtBolDetailsId: number): Observable<any> {
    return this.http.get(this.baseURI + frtBolDetailsId + '/frtBolDetailsId');
  }

  saveShipmentDeliveryDataEntity(frtShipmentDeliveryEntity: FrtShipmentDeliveryEntity): Observable<any> {
    return this.http.post<any>(this.baseURI + 'saveShipmentDeliveryData', frtShipmentDeliveryEntity, {headers: this.headers});
  }

  getShipmentDeliveryWithExceptionCodeByFrtBolDetailsIdAndOrganizationId(frtBolDetailsId: number, organizationId: number): Observable<any> {
    return this.http.get(this.baseURI + frtBolDetailsId + '/frtBolDetailsId/'+organizationId+'/organizationId');
  }
}
